export enum SearchCategories {
  ALL_CATEGORIES = 'All categories',
  PROJECTS = 'Projects',
  COMMUNITIES = 'Communities',
  USERS = 'Users',
  ORGANIZATIONS = 'Organizations',
  INDIVIDUALS = 'Individuals',
  DOCTORS = 'Doctors',
  PATIENTS = 'Patients',
  MED_STAFF = 'Med Staff',
  RESEARCHERS = 'Researchers',
  POSTS = 'Posts',
  COMMENTS = 'Comments',
}

export enum SearchAggregationBy {
  CONTINENT = 'continent',
  COUNTRY = 'country.alpha2',
  REGION = 'region',
  SUBREGION = 'subregion',
}

export enum SearchQueryMode {
  FULL = 'Full',
  NAMES = 'Names',
}

export enum SearchStrategyTypes {
  DEFAULT,
  INVITE,
  MAP,
  ENTITY_NAME,
  INVITE_NAMES,
}
export enum SortByOptions {
  NEWEST = 'SORT_BY_NEWEST',
  OLDEST = 'SORT_BY_OLDEST',
  NAME_A_Z = 'SORT_BY_A_Z',
  NAME_Z_A = 'SORT_BY_Z_A',
  SCORE = 'SORT_BY_SCORE',
}

export enum SearchResultSorting {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  RELEVANCE = 'RELEVANCE',
}
